import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import I18n from "i18next";
import { signUp, resendOTP, register, selectLoginDetails } from "store/slices/authPages";
import Register from "components/auth/Register";
import VerifyOtp from "components/auth/VerifyOtp";
import findError from "utils/findError";

export default function RegisterPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [otpSubmitting, setOtpSubmitting] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });
  const [isCaptchaSuccess, setIsCaptchaSuccess] = useState(false);
  const url = useLocation();
  const showOtp = url.search.includes("verifyOtp");
  const loginData = useSelector(selectLoginDetails);
  const email = formData?.companyEmail || loginData?.email;

  async function handleSubmit(data) {
    if (data.username) return;
    try {
      await dispatch(signUp(data));
      setFormData(data);
      setShowNotification({ type: "success", message: I18n.t("authPages.otpSentAlert") });
    } catch (error) {
      setShowNotification({ type: "error", message: findError(error.name) });
    }
  }

  function handleSignIn(e) {
    e.preventDefault();
    navigate("/sign-in");
  }

  async function handleValidateOtp(otp) {
    setOtpSubmitting(true);
    setShowNotification(false);
    try {
      await dispatch(register(formData, otp, loginData));
    } catch (error) {
      setShowNotification({ type: "error", message: findError(error.name) });
    }
    setOtpSubmitting(false);
  }

  async function handleResendOTP() {
    setShowNotification(false);
    try {
      await dispatch(resendOTP(email));
      setShowNotification({
        type: "success",
        message: I18n.t("authPages.otpSentAlert")
      });
    } catch (error) {
      setShowNotification({
        type: "error",
        message: findError(error.name)
      });
    }
  }

  function handleAlertClose() {
    setShowNotification({ type: "", message: "" });
  }

  function handleCaptchaSuccess() {
    setIsCaptchaSuccess(true);
  }

  const showOtpScreen = formData || showOtp;
  const showRegisterScreen = !formData && !showOtp;

  return (
    <>
      {showRegisterScreen && (
        <Register
          isCaptchaSuccess={isCaptchaSuccess}
          onCaptchaSuccess={handleCaptchaSuccess}
          onSubmit={handleSubmit}
          onSignIn={handleSignIn}
          showNotification={showNotification}
          onAlertClose={handleAlertClose}
        />
      )}
      {showOtpScreen && (
        <VerifyOtp
          showNotification={showNotification}
          loading={otpSubmitting}
          onSubmit={handleValidateOtp}
          onResend={handleResendOTP}
          onAlertClose={handleAlertClose}
        />
      )}
    </>
  );
}
